import { gql } from "@apollo/client"
import { ChangePartnershipTierModalPartnershipFragment } from "./fragments"

export const UPDATE_PARTNERSHIP_TIER = gql`
    mutation PartnershipChangePartnershipTier(
        $partnership: String!
        $item: String!
        $paymentMethod: String
    ) {
        partnershipChangePartnershipTier(
            partnership: $partnership
            item: $item
            paymentMethod: $paymentMethod
        ) {
            partnership {
                id
                price {
                    id
                    monthlyUnitAmount
                }
                ...ChangePartnershipTierModalPartnershipFragment
            }
            userError {
                message
            }
        }
    }
    ${ChangePartnershipTierModalPartnershipFragment}
`
